<!--
 * @Description: 客户签约主体列表页
 * @Author: cxh
 * @Date: 2023-02-22 09:22:15
 * @LastEditTime: 2023-02-24 15:58:10
 * @LastEditors: cxh
-->
<template>
  <cos-table :columns="columns" @fetch="getList" @mask="showMask" :tableId="tableIdByPath('mainBody')">
    <template #bodyCell="{ column, text }">
      <template v-if="column.dataIndex === 'customer.sellerRegion'">
        <CustomerAreaCascaderText appId="cos_fbu" :value="text" />
      </template>
      <template v-if="column.dataIndex === 'signBodyBalanceList'">
        {{ text?.map((item: any) => `${item.currencyCode}：${item.quota}`).join('、') || '--' }}
      </template>
    </template>
  </cos-table>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import { mainBodyList, mainBodyDetail } from '@/api/gucangSales/customerCenter'
import { mainBodyStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { useRoute } from 'vue-router'
import { tableIdByPath } from '@/utils'
const route = useRoute()

const columns = computed(() => [
  { title: '子客户代码', dataIndex: 'customerCode' },
  { title: '账户编号', dataIndex: 'accountCode', headerQuestion: '取值来源：ark签约主体管理-账户编号' },
  { title: '签约主体', dataIndex: 'signBodyName', headerQuestion: '取值来源：ark签约主体管理-主体名称' },
  { title: '服务主体', dataIndex: 'serviceBodyName', headerQuestion: '取值来源：ark签约主体管理-服务主体' },
  {
    title: '主体联系人',
    dataIndex: 'contactName',
    cosType: 'mask',
    headerQuestion: '取值来源：ark签约主体管理-联系人姓名',
    width: 130
  },
  {
    title: '主体手机号码',
    dataIndex: 'phoneNumber',
    cosType: 'mask',
    headerQuestion: '取值来源：ark签约主体管理-联系电话',
    width: 145
  },
  {
    title: '可用余额',
    dataIndex: 'signBodyBalanceList',
    headerQuestion: '取值来源：ark签约主体管理-可用余额',
    width: 200
  },
  { title: '信用额度', dataIndex: 'totalQuota', headerQuestion: '取值来源：ark签约主体管理-信用额度' },
  { title: '总可用额度', dataIndex: 'allTotal', headerQuestion: '取值来源：ark签约主体管理-总可用额度', width: 130 },
  { title: '出账周期', dataIndex: 'accountCycleTypeStr', headerQuestion: '取值来源：ark签约主体管理-出账周期' },
  { title: '对账周期', dataIndex: 'reconciliationCycleTypeStr', headerQuestion: '取值来源：ark签约主体管理-对账周期' },
  { title: '签约业务', dataIndex: 'signBusinessTypeStr', headerQuestion: '取值来源：ark签约主体管理-签约业务' },
  {
    title: '已签约业务',
    dataIndex: 'contractedBusinessStr',
    headerQuestion: '取值来源：ark签约主体管理-已签约业务',
    width: 130
  },
  {
    title: '注册国家/区域',
    dataIndex: 'registerAreaCode',
    headerQuestion: '取值来源：ark签约主体管理-注册国家/区域',
    width: 160
  },
  {
    title: '主体类别',
    dataIndex: 'type',
    dicData: [
      { value: 'C101', label: '个人' },
      { value: 'C102', label: '公司' }
    ],
    headerQuestion: '取值来源：ark签约主体管理-主体类别'
  },
  {
    title: '状态',
    dataIndex: 'signBodyStatus',
    dicData: mainBodyStatusEnum,
    headerQuestion: '取值来源：ark签约主体管理-状态'
  },
  { title: '审核时间', dataIndex: 'examineTime', headerQuestion: '取值来源：ark签约主体管理-审核时间', width: 190 },
  {
    title: '客户负责人',
    dataIndex: ['customer', 'sellerName'],
    headerQuestion: '取值来源：ark签约主体管理-销售代表',
    width: 130
  },
  { title: '负责人区域', dataIndex: ['customer', 'sellerRegion'], width: 190 }
])
const getList = (queryForm: any, callBack: (res: any) => void) => {
  if (route.query.cosId) {
    mainBodyList({
      customer: {
        cosId: route.query.cosId
      },
      ...queryForm
    }).then((res) => {
      callBack(res)
    })
  }
}

// 获取详情信息
const showMask = (record: any, callBack: (res: any) => void) => {
  mainBodyDetail({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}
</script>
<script lang="ts">
export default { name: 'tabsMainBody' }
</script>
